import React, {useEffect, useState} from "react";
import {firebaseService} from "../services/firebaseService";

export const OnlineTag = (person) => {
    const [online, setOnline] = useState(false);

    const isUserOnline = async (person) => {
        return await firebaseService.isUserOnline(person);
    }

    useEffect(() => {
        if (person) {
            isUserOnline(person.person).then((response) => {
                setOnline(response)
            });
        }
    });

    return <>{online && <span className="online-badge"/>}</>
};

export default OnlineTag;
